"use strict";
// Simple config version
// https://dev.to/ms_yogii/react-adding-configurations-to-your-app-at-runtime-2ihm
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppConfig = void 0;
var common_1 = require("../util/common");
// Complete config version
// https://www.freecodecamp.org/news/how-to-implement-runtime-environment-variables-with-create-react-app-docker-and-nginx-7f9d42a91d70/
// @ts-expect-error runtime-injected by nginx env script
var env = window._env_ || {};
var FALLBACK_API_TIMEOUT = 30000;
var FALLBACK_IFRAME_TIMEOUT = 30000;
var AppConfig = /** @class */ (function () {
    function AppConfig() {
        Object.defineProperty(this, "getApiBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return env.BASE_URL; }
        });
        Object.defineProperty(this, "getExamWebBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return env.EXAM_WEB_BASE_URL; }
        });
        Object.defineProperty(this, "getMaintenancePageUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return env.MAINTENANCE_PAGE_URL; }
        });
        Object.defineProperty(this, "getGoogleClientId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                return ((typeof env.GOOGLE_CLIENT_ID === "string"
                    ? env.GOOGLE_CLIENT_ID
                    : undefined) ||
                    (typeof env.REACT_APP_GOOGLE_CLIENT_ID === "string"
                        ? env.REACT_APP_GOOGLE_CLIENT_ID
                        : undefined) ||
                    process.env.GOOGLE_CLIENT_ID ||
                    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
                    "").trim();
            }
        });
        Object.defineProperty(this, "getFacebookAppId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                return ((typeof env.FACEBOOK_APP_ID === "string"
                    ? env.FACEBOOK_APP_ID
                    : undefined) ||
                    (typeof env.REACT_APP_FACEBOOK_APP_ID === "string"
                        ? env.REACT_APP_FACEBOOK_APP_ID
                        : undefined) ||
                    process.env.FACEBOOK_APP_ID ||
                    process.env.REACT_APP_FACEBOOK_APP_ID ||
                    "").trim();
            }
        });
        Object.defineProperty(this, "getLineChannelId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                return ((typeof env.LINE_CHANNEL_ID === "string"
                    ? env.LINE_CHANNEL_ID
                    : undefined) ||
                    (typeof env.REACT_APP_LINE_CHANNEL_ID === "string"
                        ? env.REACT_APP_LINE_CHANNEL_ID
                        : undefined) ||
                    process.env.LINE_CHANNEL_ID ||
                    process.env.REACT_APP_LINE_CHANNEL_ID ||
                    "").trim();
            }
        });
        Object.defineProperty(this, "getLineRedirectUri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                return ((typeof env.LINE_REDIRECT_URI === "string"
                    ? env.LINE_REDIRECT_URI
                    : undefined) ||
                    (typeof env.REACT_APP_LINE_REDIRECT_URI === "string"
                        ? env.REACT_APP_LINE_REDIRECT_URI
                        : undefined) ||
                    process.env.LINE_REDIRECT_URI ||
                    process.env.REACT_APP_LINE_REDIRECT_URI ||
                    "").trim();
            }
        });
        Object.defineProperty(this, "getApiTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                return (0, common_1.isNumber)(env.API_TIMEOUT)
                    ? Number(env.API_TIMEOUT)
                    : FALLBACK_API_TIMEOUT;
            }
        });
        Object.defineProperty(this, "getIframeTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                return (0, common_1.isNumber)(env.IFRAME_TIMEOUT)
                    ? Number(env.IFRAME_TIMEOUT)
                    : FALLBACK_IFRAME_TIMEOUT;
            }
        });
        Object.defineProperty(this, "getGroupImageBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return env.GROUP_IMAGE_BASE_URL; }
        });
        Object.defineProperty(this, "getProductImageBaseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return env.PRODUCT_IMAGE_BASE_URL; }
        });
        Object.defineProperty(this, "getDebugLog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return env.DEBUG_LOG === "TRUE"; }
        });
    }
    return AppConfig;
}());
exports.AppConfig = AppConfig;
exports.default = new AppConfig();
